import React from 'react';
import '../CSS/App.css';
import Heading from './Heading'
import SearchBar from './SearchBar'

function App() {
  return (
    <div><Heading /><SearchBar /></div>

  );
}

export default App;
